var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('table',{attrs:{"scroll":"no"}},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column,index){return _c('th',{key:index},[_vm._v(_vm._s(column))])}),0)]),_vm._v(" "),_c('tbody',[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b48a94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TableView.vue
// module id = null
// module chunks = 